import { selectCurrentTagById } from 'ducks/tags/selectors'
import { useSelector } from 'react-redux'

export default function TagLabel({ labelId }) {
  const { name = 'REMOVED' } =
    useSelector(state => selectCurrentTagById(state, labelId)) || {}
  return <>{name}</>
}
